const { event } = require("jquery")

$(document).on ('ajax:success', '#createPdf', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#createPdf .modal-body')
  div = $('<div id="createPdfError" class="alert alert-info alert-dismissable" role="alert"></div>').text(data.messages)
  close = $('<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>')
  div.prepend(close)

  if ($('#createPdfError')[0]) {
    $('#createPdfError').remove()
    form.prepend(div)
  } else {
    form.prepend(div)
  }

  // url : /console/rooms/:room_id/machines/download_pdf?
  url = $('#data-store').data('redirect-path-pdf-dl-succeed') + '?'
  $.each(data.machine_ids, (idx, id) => {
    url = url + "machine_ids[]=" + id + "&"
  })

  window.location.href = url
})

$(document).on ('ajax:error', '#createPdf', (event) => {
  data = event.detail[0], http_status = event.detail[1], xhr = event.detail[2]
  form = $('#createPdf .modal-body')
  div = $('<div id="createPdfError" class="alert alert-danger alert-dismissable" role="alert"></div>').text(data.messages)
  close = $('<button class="btn-close" type="button" data-bs-dismiss="alert" aria-label="Close"></button>')
  div.prepend(close)

  if ($('#createPdfError')[0]) {
    $('#createPdfError').remove()
    form.prepend(div)
  } else {
    form.prepend(div)
  }
})

$(document).on ('click', '#all_id_checkbox', () => {
  $('.id_checkbox').prop('checked', $('#all_id_checkbox').prop('checked'))
})

$(document).on ('click', '.id_checkbox', () => {
  if ($('#check-machines :checked').length == $('#check-machines :input').length){
    $('#all_id_checkbox').prop('checked', true)
  } else {
    $('#all_id_checkbox').prop('checked', false)
  }
})

changeDurationDisabled = (selector, model_category) => {
  if (model_category == 'other') {
    selector.prop('disabled', true)
    selector.val('')
  } else {
    selector.prop('disabled', false)
  }
}

changePriceDisabled = (selector, model_category) => {
  old = selector.prop('disabled')
  if (model_category == 'other' || model_category == 'dryer') {
    selector.prop('disabled', true)
  } else {
    selector.prop('disabled', false)
  }
  if (selector.prop('disabled') != old) {
    selector.val('')
  }
}

changeDefaultAmountDisabled = (selector, model_category) => {
  if (model_category == 'washer_dryer' || model_category == 'dryer') {
    selector.prop('disabled', false)
  } else {
    selector.prop('disabled', true)
    selector.val(1)
  }
}

$(document).on ('change', '.machine-model-selector', () => {
  model_type = $('.machine-model-selector').find('option:selected').data('model-type')
  model_category = $('.machine-model-selector').find('option:selected').data('model-category')
  model_id = $('.machine-model-selector').find('option:selected').val()

  if (model_category != null) {
    changeDurationDisabled($('.duration-input'), model_category)
    changePriceDisabled($('.price-input'), model_category)
    changeDefaultAmountDisabled($('.default-amount-input'), model_category)
  }
  
  if (model_type != 'sharp_shoes_washer_dryer') {
    $('.price-schedule-form').show()
  } else {
    $('.price-schedule-checkbox').prop('checked', false)
    $('.price-schedule-form').hide()
  }
})
